//
import Model from '@/models/Model'
import ARestoreModel from '@/models/Actions/ARestore'

//
export default class WhProductDeleted extends Model {

  /**
   * 
   */
  resource() {
    return 'wh_product_deleted'
  }

  /**
   * 
   */
  restore() {
    return this.hasMany(ARestoreModel)
  }
}